import { render, staticRenderFns } from "./confirmacionCancelacionDialog.vue?vue&type=template&id=0bd8ca96"
import script from "./confirmacionCancelacionDialog.vue?vue&type=script&lang=js"
export * from "./confirmacionCancelacionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports